export { default as Card } from "./Card";
